// extracted by mini-css-extract-plugin
export var cartContainer = "_n0-4";
export var gray = "_n0-1";
export var itemContainer = "_n0-2";
export var itemDetails = "_n0-3";
export var strong = "_n0-0";